import Handle from 'rc-slider/lib/Handle';
import { SliderProps } from 'rc-slider/lib/Slider';
import React from 'react';

import {
  cn,
  getAccessibleFocusStyles,
} from '../../../../builder-io/storyblocks-design-system/utils';

/**
 * rc-slider's default handle renderer, plus the accessible focus ring.
 * Pass as the `handle` prop of rc-slider's Range or Slider.
 */
export const renderAccessibleSliderHandle: SliderProps['handle'] = ({
  index,
  dragging: _dragging,
  ...props
}) => {
  if (props.value === null) {
    return null;
  }

  return (
    <Handle
      {...props}
      key={index}
      className={cn(props.className, getAccessibleFocusStyles())}
    />
  );
};
